import { Component, inject, OnInit } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import { Store } from "@ngrx/store";
import { getLoggedIn, getPending } from "core";
import { environment } from "projects/menus/src/environments/environment";
import { filter, switchMap, take } from "rxjs";

@Component({
  template: `<p>Loading...</p>`,
  styles: [``],
  standalone: true
})
export class LandingPage implements OnInit {

  store = inject(Store);
  router = inject(Router);
  urlSer = inject(UrlSerializer)

  ngOnInit(): void {
    // Redirect user if they are logged in
    this.store.select(getPending).pipe(
      filter(pending => !pending),
      take(1),
      switchMap(() => this.store.select(getLoggedIn).pipe(
        take(1)
      ))
    ).subscribe(loggedIn => {
      console.log('Final redirect: logged in -', loggedIn);
      
      if (loggedIn) {
        const redirectUrl: string = sessionStorage.getItem('redirectUrl');
        // sessionStorage.removeItem('redirectUrl');
        if (redirectUrl) {
          console.log('In here!');
          
          this.router.navigateByUrl(this.urlSer.parse(redirectUrl));
          // this.router.navigate([redirectUrl]);
        } else {
          location.href = `${environment.clientPortalUrl}`
        }
      }
      else
        this.router.navigate(['/login']);
    });
  }

}